import { injectIntl } from 'react-intl'
import React from 'react'

const Msg = injectIntl(({ id, defaultMessage, tag, values, intl, ...rest }) => {
  const translated = intl.formatHTMLMessage({ id, defaultMessage }, values)
  return React.createElement(tag || 'span', {
    dangerouslySetInnerHTML: { __html: translated },
    ...rest,
  })
})

const msg = props => {
  return <Msg {...props} />
}

export default msg
